export { default } from '../../../menu/(menu)/[slug]/customize';
export * from '../../../menu/(menu)/[slug]/customize';
